export default function unLoad() {
	return (dispatch) => {
		dispatch({
			type: 'UNLOAD',
		});
	};
}